import {faCheck, faUsers} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {useTranslation} from 'react-i18next'
import {createUseStyles} from 'react-jss'
import {Colors} from "../../constants/colors"
import {OpenShift} from '../../redux/types'
import {formatTimeString} from '../../util/date'
import {hoursToHoursAndMinutesString} from '../../util/hourConverter'
import ListItemCard from "../ListItemCard"
import Pagination from '../Pagination'

interface Props {
  shiftsOnPage: OpenShift[]
  pageIndex: number
  pageSize: number
  totalShiftCount: number
  onShowRecipientsClick: (openShift: OpenShift) => void
  onPageChange: (pageIndex: number) => void
}

const OpenShiftList = ({
                     shiftsOnPage,
                     pageIndex,
                     pageSize,
                     totalShiftCount,
                     onShowRecipientsClick,
                     onPageChange
                   }: Props) => {
  const styles = useStyles()
  const {t} = useTranslation(['custom', 'openShifts', 'shifts']);

  const renderHeader = () => {
    return (
      <ListItemCard className={styles.listItemContainer}>
        <div className={styles.defaultCellContainer}>
          <strong>{t('id', {ns: 'common'})}</strong>
        </div>
        <div className={styles.smallCellContainer}>
          <strong>{t('date', {ns: 'common'})}</strong>
        </div>
        <div className={styles.smallCellContainer}>
          <strong>{t('workingHours', {ns: 'shifts'})}</strong>
        </div>
        <div className={`${styles.smallCellContainer}`}>
          <strong>{t('paidWorkingHours', {ns: 'shifts'})}</strong>
        </div>
        <div className={`${styles.defaultCellContainer}`}>
          <strong>{t('location', {ns: 'common'})}</strong>
        </div>
        <div className={`${styles.defaultCellContainer}`}>
          <strong>{t('location', {ns: 'common'})}</strong>
        </div>
        <div className={`${styles.defaultCellContainer}`}>
          <strong>{t('location', {ns: 'common'})}</strong>
        </div>
        <div className={styles.smallCellContainer}>
          <strong>{t('applicantCount', {ns: 'openShifts'})}</strong>
        </div>
        <div className={styles.buttonContainer}>

        </div>
      </ListItemCard>
    )
  }

  const renderListItems = () => {
    return shiftsOnPage?.map((shift, index) => {
      return (
        <ListItemCard key={`shift${index}`} className={`${styles.listItemContainer} ${shift.deleted ? styles.deleted : ''}`} index={index}>
          <div className={styles.defaultCellContainer}>
            {shift.externalId}
          </div>
          <div className={styles.smallCellContainer}>
            {shift.date}
          </div>
          <div className={styles.smallCellContainer}>
            {`${formatTimeString(shift.startTime ?? undefined)} - ${formatTimeString(shift.endTime ?? undefined)}`}
          </div>
          <div className={`${styles.smallCellContainer}`}>
            {hoursToHoursAndMinutesString(shift.hours)}
          </div>
          <div className={styles.defaultCellContainer}>
            {shift.location1}
          </div>
          <div className={styles.defaultCellContainer}>
            {shift.location2}
          </div>
          <div className={styles.defaultCellContainer}>
            {shift.location3}
          </div>
          <div className={styles.smallCellContainer}>
            {shift.applicantCount ?? 0}
          </div>
          <div className={styles.buttonContainer}>
            <div>
              <FontAwesomeIcon
                className={styles.button}
                icon={faUsers}
                color={Colors.gray1}
                title={t('recipients', {ns: 'common'})}
                onClick={() => onShowRecipientsClick && onShowRecipientsClick(shift)}
              />
            </div>
          </div>
        </ListItemCard>
      )
    })
  }

  return (
    <div>
      <div className={styles.container}>
        {renderHeader()}
        {renderListItems()}
      </div>
      <div className={styles.pagination}>
        <Pagination
          pageIndex={pageIndex}
          itemCount={totalShiftCount}
          pageSize={pageSize}
          siblingCount={1}
          onPageChange={onPageChange}
        />
      </div>
    </div>
  )
}

export default OpenShiftList

const useStyles = createUseStyles({
  container: {
    width: '100%',
    overflowX: 'auto',
  },
  listItemContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    alignContent: 'center',
    justifyContent: 'space-between'
  },
  deleted: {
    color: Colors.rubel_400
  },
  defaultCellContainer: {
    flexShrink: 0,
    width: 150
  },
  smallCellContainer: {
    flexShrink: 0,
    width: 100
  },
  buttonContainer: {
    flexShrink: 0,
    display: 'flex',
    width: 80,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignContent: 'center',
    paddingLeft: 0
  },
  button: {
    marginRight: 15,
    transition: '0.4s',
    '&:hover': {
      color: Colors.euro_600,
      cursor: 'pointer',
    }
  },
  pagination: {
    marginTop: 10,
    display: 'flex',
    justifyContent: 'center'
  }
})
